import { render, staticRenderFns } from "./OrderBoxEntrega.vue?vue&type=template&id=5e59a653&scoped=true&"
import script from "./OrderBoxEntrega.vue?vue&type=script&lang=js&"
export * from "./OrderBoxEntrega.vue?vue&type=script&lang=js&"
import style0 from "./OrderBoxEntrega.vue?vue&type=style&index=0&id=5e59a653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e59a653",
  null
  
)

export default component.exports